import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { LeftComponentLabel, switchWithLabel } from './settingsCommon';
import moment from 'moment';
import { MenuItem, Select } from '@mui/material';
import SelectNavBox from '../../components/common/SelectNavBox';
import { FormControlSingleNewUI, styles } from '../Profile/components/styles';
import { orderBy } from 'lodash';

const TimezoneSettings = ({updateUserData , userDataFromStore}) => {
    const [timeZones, setTimeZones] = useState([])
    const [selectedTimeZone, setSelectedTimeZone] = useState("")
    const [selectTimeZoneWidth, setSelectTimeZoneWidth] = useState(450) 
    const [switchChecked, setSwitchChecked] = useState()
    const [autoDetectedTz , setAutoDetectedTz] = useState("")
    const [isDisabledSelectTz , setIsDisabledTz] = useState(false)
    const selectedDomain = useSelector((state) => state.domain.selectedDomain)
    const selectNavRef = useRef(null)

    useEffect(() => {
      fetchTimeZone()
      updateSelectWidth(); 
      window.addEventListener('resize', updateSelectWidth); 
      return () => {
        window.removeEventListener('resize', updateSelectWidth); 
      };
    },[])

    useEffect(() => {
      if(switchChecked){
        autoDetectTimeZone()
        setIsDisabledTz(true)
      } else{
        setIsDisabledTz(false)
      }
    },[switchChecked])


    const updateSelectWidth = () => {
      const selectTzWidth = selectNavRef.current?.clientWidth;
      if (selectTzWidth) {
        setSelectTimeZoneWidth(selectTzWidth);
      }
    };

    const autoDetectTimeZone = () => {
        const getTimezone = () => {
          const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          return timezone;
        };
    
        const timezone = getTimezone();
        setSelectedTimeZone(timezone);
        updateUserData("userTimezone", timezone)
        setAutoDetectedTz(timezone)
    }

    useEffect(() => {
      if(userDataFromStore){
        let {userTimezone} = userDataFromStore
        if(userTimezone && timeZones.length > 0){
          setSelectedTimeZone(userTimezone)
        }
      }
    },[timeZones])

    const fetchTimeZone = () => {
      let timeZones = moment.tz.names()
      let offsetTmz = [];
      offsetTmz = timeZones?.map((i, number) => {
        return {
          value: i,
          placeholder: "(GMT " + moment.tz(i).format("Z") + ") " + i,
          time: parseFloat(moment.tz(i).format("Z").split(":").join("")) * 0.01,
        };
      });
      setTimeZones(orderBy(offsetTmz, ["time"], ["asc"]))
    }

    const selectTimezone = (e) => {
      let selectedTz = e.target.value
      setSelectedTimeZone(selectedTz)
      updateUserData("userTimezone", selectedTz )

      if(selectedTz !== autoDetectedTz){
        setSwitchChecked(false)
      } 
    }

    return (
      <div className='settings-timezone-container'>
        <div ref={selectNavRef}>
          <SelectNavBox id="auto-detect-tz"  leftNavComponent={<LeftComponentLabel label={"Automatic detect settings"} />} rightNavComponent={switchWithLabel("", switchChecked, setSwitchChecked)} />
        </div>

        <div className={`settings-select-tz-heading ${selectedDomain}_font`}>Timezone</div>

        <div className='settings-select-tz'>
          <FormControlSingleNewUI>
            <Select
              id="timezone-settings"
              value={selectedTimeZone}
              onChange={selectTimezone}
              variant="outlined"
              disabled={isDisabledSelectTz}
              style={{
                width: `${selectTimeZoneWidth}px`,
                fontSize: "14px",
                height: "50px",
                backgroundColor: "inherit",
              }}
              MenuProps={styles.selectMenuPropsTz}
            >
              <MenuItem>Select Timezone</MenuItem>
              {timeZones?.map((timezone, index) => {
                return (
                  <MenuItem
                    key={index}
                    value={timezone.value}
                  >
                    {timezone.placeholder}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControlSingleNewUI>
        </div>

      </div>
    )
  }

  export default TimezoneSettings